export default {
  isOpen: state => state.isOpen,
  openingHours: state => state.openingHours,
  tenantDetails: state => state.tenantDetails
}
